// La page /auth-bridge (Redirect URI déclarée sur Entra ID) ne fait que relayer la réponse MSAL
// à la fenêtre principale : on ne charge pas l'application dans ce cas.
if (window.location.pathname === '/auth-bridge') {
  import('@azure/msal-browser/redirect-bridge')
    .then(({ broadcastResponseToMainFrame }) => broadcastResponseToMainFrame())
    .catch((err) => console.error('[MSAL]', err));
} else {
  import('./bootstrap');
}
